import { switchAnatomy as c } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as l, defineStyle as n } from "@chakra-ui/react";
import { cssVar as r, calc as s } from "@chakra-ui/theme-tools";
const { defineMultiStyleConfig: h, definePartsStyle: i } = l(c.keys), t = r("switch-track-width"), e = r("switch-track-height"), a = r("switch-track-diff"), b = s.subtract(t, e), o = r("switch-thumb-x"), f = n({
  borderRadius: "full",
  p: "2px",
  width: [t.reference],
  height: [e.reference],
  transitionProperty: "common",
  transitionDuration: "fast",
  bg: "gray.300",
  _hover: {
    bg: "gray.400"
  },
  _focusVisible: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.5,
    cursor: "not-allowed",
    _hover: {
      bg: "gray.300"
    }
  },
  _checked: {
    bg: "teal.500",
    _hover: {
      bg: "teal.600"
    },
    _disabled: {
      _hover: {
        bg: "teal.500"
      }
    }
  }
}), d = n({
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [e.reference],
  height: [e.reference],
  _checked: {
    transform: `translateX(${o.reference})`
  }
}), m = i({
  container: {
    display: "flex",
    alignItems: "center",
    [a.variable]: b,
    [o.variable]: a.reference,
    _rtl: {
      [o.variable]: s(a).negate().toString()
    }
  },
  track: f,
  thumb: d
}), g = {
  sm: i({
    container: {
      [t.variable]: "1.375rem",
      [e.variable]: "0.75rem"
    }
  }),
  md: i({
    container: {
      [t.variable]: "1.875rem",
      [e.variable]: "1rem"
    }
  })
}, p = h({
  baseStyle: m,
  sizes: g,
  defaultProps: { size: "md", colorScheme: "blue" }
});
export {
  p as default
};
